import { inject } from '@angular/core';
import { provideAppInitializer } from '@angular/core';
import { PluginRegistryService } from './plugin-registry.service';

export function providePluginExecution() {
  return [
    provideAppInitializer(() => {
      const registry = inject(PluginRegistryService);
      registry.runAll();
    }),
  ];
}
